import NoUserImage from '@kamernet/assets/no-user-image.webp';

export function handleUserImageError(
  e: React.SyntheticEvent<HTMLImageElement>,
) {
  const img = e.target as HTMLImageElement;
  img.onerror = null; // Prevent infinite looping in case fallback image fails
  img.src = NoUserImage.src;
}
